import React from "react";

function Export({ exportCsv, exportPdf }) {
  return (
    <div className="dropdown">
      <button
        className="btn p-2"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="bi bi-three-dots" style={{ color: "#83c14a" }}></i>
      </button>

      <ul className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton1">
        <li className="mb-2">
          <button
            className="btn w-100 text-white"
            style={{ backgroundColor: "#64c339", borderRadius: "12px" }}
            onClick={exportCsv}
          >
            <i className="fas fa-file-csv me-2"></i> Export CSV
          </button>
        </li>
        <li>
          <button
            className="btn w-100 text-dark"
            style={{ backgroundColor: "#e5e942", borderRadius: "12px" }}
            onClick={exportPdf}
          >
            <i className="fas fa-file-pdf me-2 text-danger"></i> Export PDF
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Export;
